<template>
<div :style="'background:url(' + require('@/assets/bg-top-right.png') +') fixed '" style="margin-top:200px">

     <v-row v-if="!isLoading">
          <v-col class="py-0 px-0" cols="4"></v-col>
          <v-col class="py-0 px-0" cols="4">
               <div class="text-center mb-12">
                    <span :style="'font-weight: bold;font-size:18px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P6S1HeadTitle') }}</span>
                    <h1 class="textSizeT">{{ getName('P6S1Title') }}</h1>
                    <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D') "></div>
               </div>
          </v-col>
          <v-col cols="3"></v-col>
          <v-col id=" hidden-sm-and-down" cols="1">
               <v-row @click="resultRoute" class=" hand goToResult">
                    <v-col class="py-0 " cols="12" lg="7" md="7">
                         <div style="background:#fff; border-radius:50%;padding:15px" class="shadow-drop-center" size="140">
                              <v-img style=" border-radius:30%" width="250" :src="require('@/assets/signature.gif')"></v-img>
                         </div>
                    </v-col>
                    <!-- <v-col class="py-5 hidden-s8-and-down" cols="3" lg="4" md="4">
                                        <h1 style="color: #888">{{$t('result')}}</h1>
                                        <h3 style="color: #aaa">{{$t('clickHere')}}</h3>
                                   </v-col> -->
               </v-row>
          </v-col>
     </v-row>
     <v-row v-else>
          <v-col cols="4"></v-col>
          <v-col cols="4">
               <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
               <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader><br><br>
          </v-col>
          <v-col cols="4"></v-col>
     </v-row>

     <section v-if="!isLoading" style="height:400px">
          <GmapMap :options="{
                              zoomControl: true,
                              mapTypeControl: true,
                              scaleControl: true,
                              streetViewControl: true,
                              rotateControl: true,
                              fullscreenControl: true,
                              disableDefaultUi: true
                         }" ref="mapRef" v-bind:center="center" :zoom="17" map-type-id="terrain" style="width: 100%; height: 100%">
               <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :draggable="true" />
          </GmapMap>
     </section>
     <section v-else style="height:400px">
          <v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader>
     </section>

     <section style="margin-top:120px;background: #F6F7F9" class=" px-8 py-5">
          <v-row>
               <v-col cols="12" lg="6" md="6" sm="12">
                    <div class=" mb-5">
                         <h1 v-if="!isLoading" class="textSizeST">{{ $t('clinicLocation') }}</h1>
                         <v-skeleton-loader v-else ref="skeleton" type="text"></v-skeleton-loader>
                         <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D')"></div>
                    </div>
                    <v-row v-if="!isLoading">
                         <v-col cols="1">
                              <v-icon :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-map-marker</v-icon>
                         </v-col>
                         <v-col cols="11">
                              <p class="textSizeP2">{{ getWilaya + ' , ' + getCommune }} </p>
                              <p class="textSizeP2">{{ (settings[0] && settings[0].adresse ) ? settings[0].adresse : '-----------------' }} </p>
                         </v-col>
                    </v-row>
                    <v-skeleton-loader v-else ref="skeleton" type="paragraph"></v-skeleton-loader>

               </v-col>
               <v-col cols="12" lg="6" md="6" sm="12">
                    <div class=" mb-5">
                         <h1 v-if="!isLoading" class="textSizeST">{{ $t('contactWithUs') }}</h1>
                         <v-skeleton-loader v-else ref="skeleton" type="text"></v-skeleton-loader>
                         <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D')"></div>
                    </div>
                    <v-row v-if="!isLoading">
                         <v-col cols="1">
                              <v-icon :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-phone</v-icon>
                         </v-col>
                         <v-col cols="11">
                              <p class="textSizeP2"> {{$t('phone') + ': '+  (settings[0] ? settings[0].telephone.replace(/ /g, "") : ' -- -- -- -- -- --') }}</p>
                              <p class="textSizeP2"> {{ $t('fax') +': '+ (settings[0] ? settings[0].fax.replace(/ /g, "")  : ' -- -- -- -- -- --') }}</p>
                         </v-col>
                         <v-col cols="1">
                              <v-icon :color="(settings[0] ? settings[0].color : '#2F839D')">mdi-email</v-icon>
                         </v-col>
                         <v-col cols="11">
                              <p class="textSizeP2">{{ settings[0] ? settings[0].email : '-- -- -- -- -- --' }}</p>
                         </v-col>
                    </v-row>
                    <div v-else>
                         <v-skeleton-loader ref="skeleton" type="paragraph"></v-skeleton-loader>
                         <v-skeleton-loader ref="skeleton" type="paragraph"></v-skeleton-loader>
                    </div>
               </v-col>
          </v-row>
     </section>

     <section v-if="status[2].status == 1" style="margin-top:120px">
          <v-row>
               <v-col v-if="!isLoading" cols="12" lg="6" md="6" sm="12">
                    <p class="textSizeST" :style=" 'color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P6S2SouTitle1') }}</p>
                    <p class="textSizeP">{{ getName('P6S2Prag1') }}</p>
               </v-col>
               <v-col v-else cols="12" lg="5" md="5" sm="12">
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                    <v-skeleton-loader ref="skeleton" type="paragraph"></v-skeleton-loader>

               </v-col>
               <v-col cols="12" lg="6" md="6" sm="12">
                    <v-card v-if="!isLoading" class="mx-auto2" max-width="700">
                         <v-card flat>
                              <v-card-text>
                                   <v-row>
                                        <v-col cols="12" md="12">
                                             <v-text-field v-model="form.nom" clearable outlined hide-details dense :label="$t('vNom')" required>
                                             </v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="12">
                                             <v-text-field v-model="form.email" clearable outlined hide-details dense :label="$t('vEmail')" required>
                                             </v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="12">
                                             <v-textarea v-model="form.message" clearable dense outlined hide-details :label="$t('msg') "></v-textarea>
                                        </v-col>

                                   </v-row>
                              </v-card-text>
                         </v-card>

                         <v-card-actions>
                              <v-btn v-if="!loading" class="ma-2" @click="sendToEmail" style="border-radius:30px" outlined dark :color="(settings[0] ? settings[0].color : '#2F839D')"> {{ $t('send') }} </v-btn>
                              <span class="pa-2" v-else>{{ $t('patienter') }}</span>
                         </v-card-actions>
                    </v-card>
                    <v-skeleton-loader v-else ref="skeleton" type="card-avatar, article, actions"></v-skeleton-loader>
               </v-col>
          </v-row>
     </section>

     <v-dialog v-model="dialog22" persistent max-width="400">
          <v-card>
               <v-card-title class="headline">
                    {{ $t('checkEmailHeader') }}
                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="red" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <p>{{ $t('textEmailVirify') }}</p>
                    <v-text-field class="mb-4" hide-details v-model="codeFromFeild" dense :label="$t('code')" outlined></v-text-field>
                    <a @click="sendToEmail">{{ $t('resyee') }}</a>
               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :class="this.localLang == 'fr' ? 'mr-3' : 'ml-3'" v-if="!loading" dark :color="(settings[0] ? settings[0].color : '#2F839D')" @click="sendMsg">{{ $t('virify') }}</v-btn>
                    <span :style="'color:'+(settings[0] ? settings[0].color : '#2F839D')" v-else>{{ $t('patienter') }}</span>

               </v-card-actions>
          </v-card>
     </v-dialog>
</div>
</template>

<script>
export default {
     data: () => ({
          form: {},
          codeFromFeild:'',
          codeFromEmail:'',
          loading: false,
          compt:0,
          dialog22:false,
          center: {
               lat: 36.258265117286996,
               lng: 2.228445082902901
          },
          markers: [{
               name: "House of Aleida Greve",
               description: "description 1",
               position: {
                    lat: 36.258265117286996,
                    lng: 2.2286449074745107
               }
          }, ],
     }),
     methods: {
          close() {
               this.dialog22 = false
          },
          init() {
               this.form = {
                    type: 0,
                    nom: '',
                    email: '',
                    message: '',
                    webname: 'Dr. Sarmoum Ahmed',
                    sujet: '',
                    reponse: '',
                    domainName: document.location.origin,
               }
          },
          sendToEmail () {
               if (this.compt <= 3) {
                    this.compt++
                    this.loading = true
                    var url = 'getMessage/virifyEmail'
                    var commit = 'getMessage'

                    this.$Register({
                         data: JSON.stringify(this.form)
                    }, url, commit).then((res) => {
                         this.loading = false
                         this.codeFromEmail = res
                         this.dialog22 = true 
                    }).catch((ree) => {
                         this.loading = false
                    })
               } else {
                    this.dialog22 = false
                    this.compt = 0
                    localStorage.getItem('lang') == 'fr' ? toastr.warning("Vérifiez l'e-mail s'il est correct", "Attention") : toastr.warning("تأكد من البريد الإلكتروني إذا كان صحيح", "تحذير")
               }
          },
          sendMsg() {
               if (this.codeFromEmail.success.match(/454E58D460212Y(.*)R44R554/)[1] == this.codeFromFeild + "") {
                    this.loading = true
                    var url = 'getMessage/sendMsg'
                    var commit = 'getMessage'

                    this.$Register({
                         data: JSON.stringify(this.form)
                    }, url, commit).then((r) => {
                         this.loading = false
                         this.dialog22 = false
                         this.codeFromEmail = ""
                         this.codeFromFeild = ""
                         this.init()
                    }).catch((ree) => {
                         this.loading = false
                    })
                } else {
                    localStorage.getItem('lang') == 'fr' ? toastr.error("Ce code est faux!", "Attention") : toastr.error("هذا الرمز خاطئ!", "تحذير")
               }

          },
          resultRoute() {
               this.$router.push('resultats')
          },
          /********************************** */
          isShow(item) {
               let array = this.$store.state.status.filter(e => e.idPage == 6)
               if (array) {
                    for (let i = 0; i < array.length; i++) {
                         if (array[i].idSection == item) {
                              return false
                         } else {
                              return true
                         }
                    }
               }
               return true
          },
          /********************************** */
     },
     computed: {

     },

     created() {
          this.init()
     }
}
</script>

<style>

</style>
